import {
  CommonHelperFunctions,
  IAMapSetting,
  IAMapWebServiceSetting,
  IAWSSetting,
  IAdiRegistrationSetting,
  IAppStoreConnectApiSetting,
  IBackendUrlSetting,
  ICacheSetting,
  ITwinSetting,
  ICameraPermissionLabelSetting,
  ICommonMobileSetting,
  IConfig,
  IDBConnectionStringSetting,
  IDeleteCommonConfigResponse,
  IDocumentManagementSettings,
  IFacebookAuthSetting,
  IFirebaseSetting,
  IGenericAuthSetting,
  IGoogleAuthSetting,
  IGoogleMapsSetting,
  IGooglePlayApiSetting,
  IInversCloudBoxxSetting,
  ILDAPSetting,
  ILocationPermissionLabelSetting,
  IMSALSetting,
  INotificationPermissionLabelSetting,
  IOAuth2Setting,
  IParamPaymentSettings,
  IPasswordPolicy,
  IPushNotificationSetting,
  ISMTPSetting,
  ISearchEngineSettings,
  ISearchServiceSettings,
  IStripeSetting,
  IWhatsappBusinessTemplateModel
} from "@kuika/kuika-cl-model";
import { GetConfigsRequestDTO } from "@kuika/kuika-cl-model/src/models/config";
import Axios from "axios";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export type CommonConfig =
  | IGenericAuthSetting
  | IOAuth2Setting
  | ILDAPSetting
  | IPasswordPolicy
  | ISMTPSetting
  | IGoogleMapsSetting
  | IAMapSetting
  | IAMapWebServiceSetting
  | IAWSSetting
  | IStripeSetting
  | IGoogleAuthSetting
  | IFacebookAuthSetting
  | IAppStoreConnectApiSetting
  | IGooglePlayApiSetting
  | IFirebaseSetting
  | IPushNotificationSetting
  | ICameraPermissionLabelSetting
  | ILocationPermissionLabelSetting
  | INotificationPermissionLabelSetting
  | IInversCloudBoxxSetting
  | IMSALSetting
  | ICommonMobileSetting
  | IDBConnectionStringSetting
  | IBackendUrlSetting
  | IParamPaymentSettings
  | ISearchServiceSettings
  | ISearchEngineSettings
  | IDocumentManagementSettings
  | ICacheSetting
  | ITwinSetting
  | IAdiRegistrationSetting;

export class ConfigService {
  public static getAllConfigs(projectId: string) {
    return Axios.get<GetConfigsRequestDTO>(`${backendUrl}/Configuration/project/${projectId}`);
  }

  public static getLightweightConfigs(projectId: string) {
    return Axios.get<{ configurations: IConfig[] }>(`${backendUrl}/Configuration/project/${projectId}/lightweight`);
  }

  public static getConfig(projectId: string, configurationId: string) {
    return Axios.get(`${backendUrl}/Configuration/project/${projectId}/${configurationId}`);
  }

  public static createConfig(projectId: string, config: IConfig) {
    return Axios.post(`${backendUrl}/Configuration/project/${projectId}`, config);
  }

  public static duplicateConfig(projectId: string, configurationId: string) {
    return Axios.post(`${backendUrl}/Configuration/project/${projectId}/${configurationId}`);
  }

  public static updateConfig(projectId: string, config: IConfig) {
    return Axios.put(`${backendUrl}/Configuration/project/${projectId}`, config);
  }

  public static deleteConfig(projectId: string, configurationId: string) {
    return Axios.delete(`${backendUrl}/Configuration/project/${projectId}/${configurationId}`);
  }

  public static getCommonConfig(projectId: string, configurationKey: string) {
    return Axios.get(`${backendUrl}/Configuration/project/${projectId}/common/${configurationKey}`);
  }

  public static createCommonConfig(projectId: string, configurationKey: string, commonConfig: any) {
    return Axios.post(`${backendUrl}/Configuration/project/${projectId}/common/${configurationKey}`, commonConfig);
  }

  public static updateCommonConfig(projectId: string, configurationKey: string, commonConfig: any) {
    return Axios.put(`${backendUrl}/Configuration/project/${projectId}/common/${configurationKey}`, commonConfig);
  }

  public static deleteCommonConfig(projectId: string, configurationKey: string, configurationId: string) {
    return Axios.delete(
      `${backendUrl}/Configuration/project/${projectId}/common/${configurationKey}/${configurationId}`
    );
  }

  public static getConfigurationLocalizations() {
    return Axios.get(`${backendUrl}/Configuration/localizations`);
  }

  public static getGlobalConfigs() {
    return Axios.get<GetConfigsRequestDTO>(`${backendUrl}/Configuration/domain`);
  }

  public static getGlobalConfig(configurationId: string) {
    return Axios.get<IConfig>(`${backendUrl}/Configuration/domain/${configurationId}`);
  }

  public static createGlobalConfig(config: IConfig) {
    return Axios.post(`${backendUrl}/Configuration/domain`, config);
  }

  public static updateGlobalConfig(config: IConfig) {
    return Axios.put(`${backendUrl}/Configuration/domain`, config);
  }

  public static deleteGlobalConfig(configurationId: string) {
    return Axios.delete(`${backendUrl}/Configuration/domain/${configurationId}`);
  }

  public static getGlobalCommonConfig(configurationKey: string) {
    return Axios.get(`${backendUrl}/Configuration/domain/common/${configurationKey}`);
  }

  public static createGlobalCommonConfig(configurationKey: string, commonConfig: CommonConfig) {
    return Axios.post(`${backendUrl}/Configuration/domain/common/${configurationKey}`, commonConfig);
  }

  public static updateGlobalCommonConfig(configurationKey: string, commonConfig: CommonConfig) {
    return Axios.put(`${backendUrl}/Configuration/domain/common/${configurationKey}`, commonConfig);
  }

  public static deleteGlobalCommonConfig(configId: string, configurationKey: string, commonGlobalConfigId: string) {
    return Axios.delete<IDeleteCommonConfigResponse>(
      `${backendUrl}/Configuration/domain/common/${configId}/${configurationKey}/${commonGlobalConfigId}`
    );
  }

  public static getAllWhatsappBusinessTemplates(projectId: string) {
    return Axios.get<IWhatsappBusinessTemplateModel[]>(`${backendUrl}/Configuration/project/${projectId}/whatsapp`);
  }
}
